<template>
    <div>
        <div class="fixed inset-x-0 bottom-0 z-50 ">
            <div class="bg-output-primary ">
                <div class="max-w-screen-xl px-3 py-3 mx-auto sm:px-6 lg:px-8">
                    <div class="flex flex-wrap items-center justify-between">
                        <div class="flex items-center flex-1 w-0">
                            <svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                ></path>
                            </svg>

                            <p class="ml-3 font-medium text-white truncate">
                                <span class="md:hidden">
                                    Téléchargez votre business plan
                                </span>
                                <span class="hidden md:inline">
                                    Téléchargez votre business plan
                                </span>
                            </p>
                        </div>
                        <div
                            class="flex-shrink-0 order-3 w-full mt-2 sm:order-2 sm:mt-0 sm:w-auto"
                        >
                            <div class="rounded-md shadow-sm">
                                <button
                                    @click="DownloadDF"
                                    class="flex items-center justify-center px-4 py-2 text-sm font-medium leading-5 text-gray-900 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline"
                                >
                                    Téléchargez
                                </button>
                            </div>
                        </div>
                        <div
                            class="flex-shrink-0 order-2 sm:order-3 sm:ml-3"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import NProgress from "nprogress";

export default {
    mounted() {
        var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

        function preventDefault(e) {
            e.preventDefault();
        }

        function preventDefaultForScrollKeys(e) {
            if (keys[e.keyCode]) {
                preventDefault(e);
                return false;
            }
        }

        // modern Chrome requires { passive: false } when adding event
        var supportsPassive = false;
        try {
            window.addEventListener(
                "test",
                null,
                Object.defineProperty({}, "passive", {
                    get: function() {
                        supportsPassive = true;
                        return "";
                    }
                })
            );
        } catch (e) {
            console.log(e);
        }

        var wheelOpt = supportsPassive ? { passive: false } : false;
        var wheelEvent =
            "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

        // call this to Disable
        function disableScroll() {
            window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
            window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
            window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
            window.addEventListener(
                "keydown",
                preventDefaultForScrollKeys,
                false
            );
        }

        // call this to Enable
        this.enableScroll = function enableScroll() {
            window.removeEventListener("DOMMouseScroll", preventDefault, false);
            window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
            window.removeEventListener("touchmove", preventDefault, wheelOpt);
            window.removeEventListener(
                "keydown",
                preventDefaultForScrollKeys,
                false
            );
        };
        disableScroll();
    },
    data() {
        return {
            enableScroll: ""
        };
    },
    methods: {
        async DownloadDF() {
            NProgress.start();

            const doc = new jsPDF({
                unit: "pt",
                format: "a4"
            });
            document.html2canvas = html2canvas;
            const pages = document.querySelectorAll(".page");
            for (const [index, page] of pages.entries()) {
                let isLandScape = page.classList
                    .toString()
                    .includes("landscape");
                if (index !== 0) {
                    if (isLandScape) {
                        await doc.addPage("a4", "l");
                    } else {
                        await doc.addPage("a4", "p");
                    }
                }
                let pageCanvas = await html2canvas(page, {
                    dpi: 144,
                    scale: 2,
                    useCORS: true,
                    removeContainer: true
                });

                let pageImg = await pageCanvas.toDataURL("image/jpeg", 1);

                if (isLandScape) {
                    await doc.addImage({
                        imageData: await pageImg,
                        format: "JPEG",
                        x: -9,
                        y: 0,
                        height: 605,
                        width: 842.25,
                        compression: "NONE"
                    });
                } else {
                    await doc.addImage({
                        imageData: await pageImg,
                        format: "JPEG",
                        x: -9,
                        y: 0,
                        height: 842.25,
                        width: 605,
                        compression: "NONE"
                    });
                }
            }

            await doc.save("sample.pdf");
            await NProgress.done();
            await this.enableScroll();
        }
    }
};
</script>
